import React from 'react';
import _ from 'underscore';
import { mergeStyles } from '@fluentui/react';
import classNames from 'classnames';
import { componentTypes, bulkRegister } from './component-types';
import { GeneratedUI } from './generated-ui';

export const generateComponents = (props) => {
  const { schema, customComponentTypes } = props;

  const selectComponentType = ({
    schemaComponent, key, commonSchemaStyles, numberOfComponents, separatorStyles,
  }) => {
    const field = schemaComponent[0];
    const params = schemaComponent[1];

    const Component = componentTypes[params.type];

    const separatorStylesForComponent = separatorStyles && key < numberOfComponents - 1 ? separatorStyles : {};

    const componentStyles = _.extend(separatorStylesForComponent, params.styles || commonSchemaStyles);
    const componentClassName = params.className || `${field}-${params.type}`;

    const { dynamicProps: getDirectlyDefinedDynamicProperties, components: componentsSchema } = params;

    const build = Component ? (propertiesSchema, dynamicProperties) => {
      const directlyDefinedComponentDynamicProperties = (dynamicProperties
        && getDirectlyDefinedDynamicProperties
        && getDirectlyDefinedDynamicProperties(dynamicProperties)) || {};
      const schemaBasedComponentDynamicProperties = (propertiesSchema && propertiesSchema[field]) || {};

      const { components: childComponentsDynamicProperties, ...rest } = schemaBasedComponentDynamicProperties;
      const componentDynamicProperties = (!_.isEmpty(directlyDefinedComponentDynamicProperties) && directlyDefinedComponentDynamicProperties) || rest;

      const dynamicallyHideComponent = componentDynamicProperties.isRendered === false;
      const componentStylesWithDynamics = mergeStyles(_.extend(componentStyles, componentDynamicProperties.styles, { display: dynamicallyHideComponent ? 'none' : 'block' }));

      return (
        <div className={classNames(componentClassName, componentStylesWithDynamics)} key={key}>
          <Component {...params} {...componentDynamicProperties}>
            {componentsSchema && <GeneratedUI schema={componentsSchema} propertiesSchema={childComponentsDynamicProperties} {...dynamicProperties} />}
          </Component>
        </div>
      );
    } : null;

    return build ? { field, build } : null;
  };

  bulkRegister(customComponentTypes);

  const { styles, separatorStyles } = schema;

  const unrenderedComponents = _.keys(_.pick(schema, c => c.isRendered === false));
  const componentsToRenderSchema = _.omit(schema, 'styles', 'separatorStyles', ...unrenderedComponents);

  const schemaComponents = _.pairs(componentsToRenderSchema);

  const selectedComponentTypes = _.map(schemaComponents, (schemaComponent, key) =>
    selectComponentType({
      schemaComponent,
      key,
      numberOfComponents: schemaComponents.length,
      commonSchemaStyles: styles,
      separatorStyles,
    }));

  return _.without(selectedComponentTypes, null);
};
